/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'down-open': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1.707 285.547c0-5.355 2.026-10.731 6.037-14.891 8.235-8.448 21.739-8.619 30.165-.405l450.539 438.805c7.723 7.552 17.408 8.213 22.485 7.957 10.88.448 18.859-2.368 24.555-7.957l450.581-438.805c8.448-8.214 21.952-8.043 30.166.405 8.213 8.427 8.042 21.952-.406 30.165L565.27 739.648c-14.336 13.91-33.621 21.035-54.336 20.01-18.624 1.046-37.93-6.08-52.245-20.01L8.171 300.843c-4.31-4.182-6.464-9.728-6.464-15.296z"/>'
  }
})
